import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogicMiddleware } from 'redux-logic';
import { debounce } from 'lodash';
import { composeWithDevTools } from 'redux-devtools-extension';
import { ajax } from 'rxjs/ajax';

import reducers from './redux/reducers';
import logics from './redux/logics';
// import App from "./react/containers/app";
import App from './App';
import { saveState, loadState } from './utility/persistentstate';
import { initConfig } from './config/config-base';

// Create Redux middleware with optional dev tools in development
const enhancer_base = applyMiddleware(
  createLogicMiddleware(logics, { ajax }),
  thunk
);
const enhancer =
  process.env.NODE_ENV !== 'production'
    ? composeWithDevTools(enhancer_base)
    : enhancer_base;

const store = createStore(reducers, loadState(), enhancer);

// Sync the Redux store with localStorage after every change.
// Debounce the sync to save performance (and avoid race conditions).
store.subscribe(debounce(() => saveState(store.getState()), 300));

const node = document.getElementById('root');
(async () => {
  try {
    const response = await fetch('/runtime-config.json');
    const config = await response.json();

    initConfig(config);

    if (!node) {
      throw new Error('Root element not found.');
    }

    render(
      <Provider store={store}>
        <App />
      </Provider>,
      node
    );
  } catch (error) {
    console.error('Failed to load:', error);
    node.innerHTML =
      '<div style="padding: 20px; color: red;">Failed to load application, check console.</div>';
  }
})();
